export const getNextPageParam = (lastPage, allPages) =>
  lastPage ? { page: allPages.length + 1 } : { page: 1 };

export default getNextPageParam;
